<template>
    <section class="gh-section s-wrapper">
        <div class="container">
            <h3 class="gh-section__heading">You Are In Control</h3>

            <p class="gh-section__subheading">
                Life has many competing demands. We make lifelong learning accessible, rewarding and easier to manage. You have total control over where, what, when, and how you learn – so you have more time to do the things you love.
            </p>

            <div class="gh-control-items">
                <div
                    v-for="(control, index) in controlList"
                    :key="index"
                    :class="'gh-control-item ' + 'gh-controls-item-'+index">
                    <div class="gh-control-item-inner">
                        <div :class="`gh-control-icon-text gh-control-icon--${index + 1}`"></div>
                        <img class="control-image" :src="'/images/eofy/' + control.icon" :alt="control.title" width="54">
                        <p class="gh-control-title" v-html="control.title"></p>
                        <p class="gh-control-description" v-html="control.description"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            controlList: {
                type: Array,
                default: () => []
            }
        }
        }
</script>

<style lang="scss" scoped>
    .s-wrapper {
        color: #005A46;
        background: #f3f3f3;

        p {
            color: #005A46;
        }
    }

    .s-controls {
        margin-top: 2rem !important;
        margin-bottom: 1rem;
    }

    .s-control {
        margin-bottom: 1rem;
    }

    .s-control__text {
        font-weight: 500;
    }

    .gh-section__subheading {
        max-width: 818px;
        margin: auto;
        text-align: center !important;
    }
    .s-control__heading {
        color: #2c3138;

        strong {
            font-weight: 800;
        }
    }

    img {
        width: 54px;
        height: auto;
    }

    .gh-control-items {
        margin-top: 0.7rem;
        margin-bottom: -3rem;
        display: flex;
        flex-flow: column;
        justify-content: center;
    }

    .gh-control-item {
        text-align: center;
        margin-bottom: 2rem;
        .gh-control-item-inner {
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
        }
    }

    .gh-control-title {
        font-size: 1.5rem;
        font-weight: 700;
        margin: 1.2rem 0 0.5rem;
    }

    .gh-control-description {
        font-weight: 500;
        font-size: 1.2rem;
        padding: 0 1.5rem;
        max-width: 403px;
    }

    .s-cta {
        margin-top: 2rem;
        text-align: center;
    }

    @media screen and (min-width: '768px') {
        .s-controls {
            max-width: 992px;
            margin: 1rem auto;
        }

        .s-control {
            margin-bottom: 1rem;
            padding: 0 1rem;

            + .s-control {
                margin-top: 0;
            }
        }
    }

    @media screen and (min-width: '1024px') {
        .gh-control-items {
            flex-flow: row wrap;
            justify-content: center;
            .gh-control-item {
                width: 33%;
                margin-bottom: 3rem;
            }
        }
    }
</style>
